import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ActionCreator from '../../store/actions';
import { Link, withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import MapIcon from '@material-ui/icons/Map';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ReportIcon from '@material-ui/icons/Report';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PeopleIcon from '@material-ui/icons/People';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { MenuList, MenuItem, Tooltip, ListItemIcon, Typography, ListItemText } from '@material-ui/core';
import { compose } from 'recompose';
import t from "../../languages/pl";
import withSubordinateUser from './../HOC/withSubordinateUser';

const useStyles = () => ({
    menuItem: {
        border: "solid",
        borderWidth: "0 0 0 5px",
        borderColor: "transparent"
    },
});

const menuButtons = [
    {
        name: t.dashboard,
        to: "/",
        icon: isActive => <DashboardIcon style={{ color: menuButtonIndicatorsColor(isActive) }} />,
        onlyAdmin: false,
        canSeeSubAdministrator: true
    },
    {
        name: t.map,
        to: "/map",
        icon: isActive => <MapIcon style={{ color: menuButtonIndicatorsColor(isActive) }} />,
        onlyAdmin: false,
        canSeeSubAdministrator: true
    },
    {
        name: t.reports,
        to: "/reports",
        icon: isActive => <ReportIcon style={{ color: menuButtonIndicatorsColor(isActive) }} />,
        onlyAdmin: false,
        canSeeSubAdministrator: true
    },
    {
        name: t.cars,
        to: "/cars",
        icon: isActive => <DirectionsCarIcon style={{ color: menuButtonIndicatorsColor(isActive) }} />,
        onlyAdmin: false,
        canSeeSubAdministrator: true
    },
    {
        name: t.drivers,
        to: "/drivers",
        icon: isActive => <PeopleIcon style={{ color: menuButtonIndicatorsColor(isActive) }} />,
        onlyAdmin: false,
        canSeeSubAdministrator: true
    },
    {
        name: t.groups,
        to: "/groups",
        icon: isActive => <GroupWorkIcon style={{ color: menuButtonIndicatorsColor(isActive) }} />,
        onlyAdmin: false,
        canSeeSubAdministrator: true
    },
    {
        name: t.users,
        to: "/manageusers",
        icon: isActive => <AccountBoxIcon style={{ color: menuButtonIndicatorsColor(isActive) }} />,
        onlyAdmin: true,
        canSeeSubAdministrator: false
    },
    {
        name: t.rents,
        to: "/rents",
        icon: isActive => <AssignmentIcon style={{ color: menuButtonIndicatorsColor(isActive) }} />,
        onlyAdmin: true,
        canSeeSubAdministrator: true
    },
    {
        name: t.settings,
        to: "/settings",
        icon: isActive => <SettingsIcon style={{ color: menuButtonIndicatorsColor(isActive) }} />,
        onlyAdmin: false,
        canSeeSubAdministrator: true
    }
];

const activeMenuButtonColor = "#A3A0FB";
const notActiveMenuButtonColor = "#A5A4BF";


const menuButtonIndicatorsColor = isActive => {
    return isActive ? activeMenuButtonColor : notActiveMenuButtonColor;
};

const MenuButtons = (props) => {
    const { classes, nonAdminUser, isGpsEnabled, role } = props;

    const handlePageChange = (itemSelected, to) => {
        if (to === '/cars' && window.location.href.includes('/cars')) {
            props.resetToDefaults();
        }
        itemSelected && window.location.assign(to);
    };

    const getMenuButtons = (buttons) => {
        return buttons.map((obj) => {
            if (obj.onlyAdmin && nonAdminUser)
                return false;

            if (obj.to === "/map" && !isGpsEnabled)
                return false;

            if (!obj.canSeeSubAdministrator && role === 'podadmin') {
                return false;
            }

            let itemSelected = window.location.pathname.startsWith(obj.to);

            if (obj.to === "/")
                itemSelected = window.location.pathname === obj.to;
            return (
                <MenuItem
                    className={classes.menuItem}
                    style={{ borderColor: itemSelected ? "#A3A0FB" : "transparent" }}
                    button
                    key={obj.name}
                    component={Link}
                    onClick={() => handlePageChange(itemSelected, obj.to)}
                    to={obj.to}
                    selected={itemSelected}>
                    <ListItemIcon>
                        <Tooltip
                            title={obj.name}
                            placement="right"
                            arrow
                            disableFocusListener
                            disableHoverListener={props.isDrawerOpen}
                        >
                            {obj.icon(itemSelected)}
                        </Tooltip>
                    </ListItemIcon>
                    <ListItemText>
                        <Typography
                            variant="subtitle1"
                            noWrap
                            color="textSecondary"
                        >
                            {obj.name}
                        </Typography>
                    </ListItemText>
                </MenuItem>
            );
        });
    };

    const handleLogoutClick = () => {
        props.logout();
    };

    return (
        <MenuList>
            {getMenuButtons(menuButtons)}
            <MenuItem
                className={classes.menuItem}
                button
                key={t.logout}
                onClick={handleLogoutClick}
            >
                <ListItemIcon>
                    <Tooltip
                        title={t.logout}
                        placement="right"
                        arrow
                        disableFocusListener
                        disableHoverListener={props.isDrawerOpen}
                    >
                        {<ExitToAppIcon style={{ color: notActiveMenuButtonColor }} />}
                    </Tooltip>
                </ListItemIcon>
                <ListItemText>
                    <Typography variant="subtitle1" noWrap color="textSecondary">
                        {t.logout}
                    </Typography>
                </ListItemText>
            </MenuItem>
        </MenuList>
    );
};

const mapStateToProps = state => {
    return {
        isGpsEnabled: state.authReducer.isGpsEnabled,
        isDrawerOpen: state.requestReducer.isDrawerOpen,
        role: state.authReducer.role
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

MenuButtons.propTypes = {
    classes: PropTypes.object,
    //redux
    isDrawerOpen: PropTypes.bool,
    logout: PropTypes.func,
    resetToDefaults: PropTypes.func,
    //withSubordinateUser
    nonAdminUser: PropTypes.bool,
    isGpsEnabled: PropTypes.bool,
    role: PropTypes.string,
    //router
    history: PropTypes.object
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withRouter,
    withStyles(useStyles),
    withSubordinateUser
)(MenuButtons);
